<template>
  <section class="c-thread" aria-label="Collaborate" data-v-step="2">
    <div class="container-fluid">
      <h2 class="fs-21 w-bold white mb-4">Únete a la discusión</h2>
      <Editor
        mode="post"
        category="comment"
        :thread.sync="comments"
        :recents.sync="recents"
        class="c-editor--main mb-4">
      </Editor>
      <div class="d-flex mb-4">
        <div class="d-flex align-items-center medium-gray">
          <i class="iconf-comments me-2 fs-18"></i>
          <span class="w-medium">{{totalComments}} Comentarios</span>
        </div>
      </div>
      <div class="c-hr bg-blacks mb-0"></div>
    </div>
    <section id="mainThread" v-if="comments.length > 0" class="pt-4">
      <ul class="c-thread__comments ul-reset">
        <li v-for="comment of comments" :key="comment.id">
          <Comment
            :body="comment"
            :answers.sync="comment.answers.data"
            :threadMetas.sync="metas"
            :thread.sync="comments" />
        </li>
      </ul>
      <div class="container-fluid">
        <div v-if="isMoreComments" class="d-flex justify-content-center mt-4">
          <button
            class="c-button c-button--primary w-100"
            :class="loadingCommentsClass"
            @click="getComments()"
          >
            Más comentarios
            <img
              class="c-button__spinner"
              src="../../../assets/images/animations/spinner-white.png"
              alt="loading"
            />
          </button>
        </div>
      </div>
    </section>
    <div v-else class="c-thread__empty d-flex flex-column align-items-center text-center pt-4">
      <figure class="mb-5">
        <img
          class="w-100 h-100 of--contain"
          src="../../../assets/images/lection/no-comments.png"
          alt=""
        >
      </figure>
      <h3 class="w-bold fs-21 white mb-2">¡Aún sin comentarios!</h3>
      <p class="mb-0 w-medium medium-gray">Sé el primero en compartir tus ideas o dudas.</p>
    </div>
  </section>
</template>

<script>
/* eslint-disable */
import {scroller} from 'vue-scrollto/src/scrollTo';

import Editor from './Editor.vue';
import Comment from './Comment.vue';

export default {
  data() {
    return {
      metas: {
        total: 0,
        currentPage: 0,
        isLoading: false,
      },
      recents: [],
      comments: [],
      scroll: scroller(),
    }
  },
  props: ['user', 'course'],
  components: {
    Editor,
    Comment,
  },
  computed: {
    isMoreComments: function() {
      return this.metas.total / 5 > this.metas.currentPage
    },
    loadingCommentsClass: function() {
      return (this.metas.isLoading) ? 'loading loading--black' : '';
    },
    totalComments: function() {
      return this.metas.total + this.recents.length;
    },
  },
  watch: {
    $route (to, from) {
      if(this.user && this.course.enroll) {
        this.resetComments();
        this.getComments(this.$route.params.module, this.$route.params.lection_slug);
      }
    },
  },
  mounted() {
    if (this.$route.query.comment) {
      this.recents.push(this.$route.query.comment);
      this.getComment(this.$route.query.comment);
    }

    this.getComments();
  },
  methods: {
    getComment: function(commentId, currentModule = this.$route.params.module, currentLection = this.$route.params.lection_slug) {
      const request = `${window.arcux.site}/api/v1/courses/${this.$route.params.course_id}/${currentModule}/${currentLection}/annotations/${commentId}`

      fetch(request, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
      .then(res => {
        if(res.status == 200 || res.status < 300) {
          return res.json()
        } else {
          throw res;
        }
      })
      .then(comment => {
        this.comments.unshift({
          ...comment,
          highlighted: true,
        });

        window.setTimeout(() => {
          this.scroll('#mainThread');
        }, 100)
      })
      .catch(err => {
        throw err;
      })
    },
    getComments: function(currentModule = this.$route.params.module, currentLection = this.$route.params.lection_slug) {
      let currentPage = this.metas.currentPage;
      let request     = `${window.arcux.site}/api/v1/courses/${this.$route.params.course_id}/${currentModule}/${currentLection}/annotations?parent=0&page=${currentPage + 1}`

      request = (this.recents.length > 0) ? `${request}&exclude=${this.recents.map(ans => ans).join(',')}` : request

      this.metas.isLoading = true;

      fetch(request, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
      .then(res => {
        if(res.status == 200 || res.status < 300) {
          return res.json()
        } else {
          throw res;
        }
      })
      .then(comments => {
        this.comments = [
          ...this.comments,
          ...comments.data,
        ]

        this.metas.total = comments.total;
        this.metas.currentPage++;
        this.metas.isLoading = false;
      })
      .catch(err => {
        this.metas.isLoading = false; throw err;
      })
    },
    resetComments: function() {
      this.metas.currentPage = 0;
      this.comments = [];
      this.recents = [];
    },
  },
}
</script>
